// extracted by mini-css-extract-plugin
export default {"root":"IntegerRangeFilter_root__TojZl","formWrapper":"IntegerRangeFilter_formWrapper__QtDAd"};